import * as types from '../services/UserActionType';

function userReducer(state = {}, action) {
    switch (action.type) {
        case types.GET_USERS_REQUEST:
            return { ...state, isUserLoading: true };
        case types.GET_USERS_SUCCESS:
            return { ...state, isUserLoading: false, userList: action.payload };
        case types.GET_USERS_FAILURE:
            return { ...state, isUserLoading: false, userList: [] };

        case types.DELETE_USER_REQUEST:
            return { ...state, isUserLoading: true };
        case types.DELETE_USER_SUCCESS:
            return { ...state, isUserLoading: false };
        case types.DELETE_USER_FAILURE:
            return { ...state, isUserLoading: false };

        case types.GET_USER_BY_ID_REQUEST:
            return { ...state, isUserLoading: true };
        case types.GET_USER_BY_ID_SUCCESS:
            return { ...state, isUserLoading: false, userDetails: action.payload };
        case types.GET_USER_BY_ID_FAILURE:
            return { ...state, isUserLoading: false, userDetails: null };

        case types.SAVE_USER_REQUEST:
            return { ...state, isUserLoading: true };
        case types.SAVE_USER_SUCCESS:
            return { ...state, isUserLoading: false };
        case types.SAVE_USER_FAILURE:
            return { ...state, isUserLoading: false };

        case types.EXPORT_USER_REQUEST:
            return { ...state, isUserLoading: true };
        case types.EXPORT_USER_SUCCESS:
            return { ...state, isUserLoading: false, userExportData: action.payload };
        case types.EXPORT_USER_FAILURE:
            return { ...state, isUserLoading: false, userExportData: null };
        case types.IMPORT_USER_REQUEST:
            return { ...state, isUserLoading: true, isFileImportLoading: true };
        case types.IMPORT_USER_SUCCESS:
            return { ...state, isUserLoading: false, isFileImportLoading: false, userImportData: action.payload };
        case types.IMPORT_USER_FAILURE:
            return { ...state, isUserLoading: false, isFileImportLoading: false, userImportData: null };
        case types.CLEAR_USER_EXPORT:
            return { ...state, userExportData: null };
        case types.CLEAR_IMPORT_USER_RESPONSE:
            return { ...state, userImportData: null };

        // File Import Details
        case types.FETCH_FILE_IMPORT_DETAILS_REQUEST:
            return { ...state, isFileImportLoading: true };
        case types.FETCH_FILE_IMPORT_DETAILS_SUCCESS:
            return {
                ...state,
                isFileImportLoading: false,
                fileImportDetailsList: action.payload.importFileDetails || [],
                fileImportTotalRecords: action.payload.totalCount || 0,
            };
        case types.FETCH_FILE_IMPORT_DETAILS_FAILURE:
            return {
                ...state,
                isFileImportLoading: false,
                fileImportDetailsList: [],
                fileImportTotalRecords: 0,
            };

        // Download imported file
        case types.DOWNLOAD_IMPORTED_FILE_REQUEST:
            return { ...state, downloadingFileId: action.payload.fileImportMasterID || action.payload.fileName, downloadFileError: null };
        case types.DOWNLOAD_IMPORTED_FILE_SUCCESS:
            return { ...state, downloadingFileId: null, downloadFileError: null };
        case types.DOWNLOAD_IMPORTED_FILE_FAILURE:
            return { ...state, downloadingFileId: null, downloadFileError: action.payload };

        // User Activity
        case types.GET_USER_ACTIVITY_REQUEST:
            return { ...state, isActivityLoading: true };
        case types.GET_USER_ACTIVITY_SUCCESS:
            return { 
                ...state, 
                isActivityLoading: false, 
                userActivityList: action.payload.activityList || action.payload || [],
                userActivityTotalRecords: action.payload.totalCount || 0
            };
        case types.GET_USER_ACTIVITY_FAILURE:
            return { ...state, isActivityLoading: false, userActivityList: [], userActivityTotalRecords: 0 };
            
        case types.RESET_MFA_REQUEST:
            return { ...state, isUserLoading: true };
        case types.RESET_MFA_SUCCESS:
            return { ...state, isUserLoading: false };
        case types.RESET_MFA_FAILURE:
            return { ...state, isUserLoading: false };

        case types.RESEND_WELCOME_EMAIL_REQUEST:
            return { ...state, isUserLoading: true };
        case types.RESEND_WELCOME_EMAIL_SUCCESS:
            return { ...state, isUserLoading: false };
        case types.RESEND_WELCOME_EMAIL_FAILURE:
            return { ...state, isUserLoading: false };

        case types.SEND_PENDING_WELCOME_EMAILS_REQUEST:
            return { ...state, isUserLoading: true };
        case types.SEND_PENDING_WELCOME_EMAILS_SUCCESS:
            return { ...state, isUserLoading: false };
        case types.SEND_PENDING_WELCOME_EMAILS_FAILURE:
            return { ...state, isUserLoading: false };

        case types.EXPORT_USER_ACTIVITY_REQUEST:
            return { ...state, isActivityExporting: true };
        case types.EXPORT_USER_ACTIVITY_SUCCESS:
            return { ...state, isActivityExporting: false, userActivityExportData: action.payload };
        case types.EXPORT_USER_ACTIVITY_FAILURE:
            return { ...state, isActivityExporting: false, userActivityExportData: null };

        case types.GET_USER_AUTHORIZED_MAPPING_REQUEST:
            return { ...state, isAuthorizedMappingLoading: true };
        case types.GET_USER_AUTHORIZED_MAPPING_SUCCESS:
            return { ...state, isAuthorizedMappingLoading: false, authorizedUsersList: action.payload.mappingList || [] };
        case types.GET_USER_AUTHORIZED_MAPPING_FAILURE:
            return { ...state, isAuthorizedMappingLoading: false, authorizedUsersList: [] };

        case types.TOGGLE_USER_AUTHORIZED_MAPPING_REQUEST:
            return { ...state, isToggleMappingLoading: true };
        case types.TOGGLE_USER_AUTHORIZED_MAPPING_SUCCESS:
            return { ...state, isToggleMappingLoading: false };
        case types.TOGGLE_USER_AUTHORIZED_MAPPING_FAILURE:
            return { ...state, isToggleMappingLoading: false };

        default:
            return state;
    }
}
export default userReducer;